module.exports = __webpack_public_path__ + "media/images/recruitment/landing/img_phone-b17a3a6246ea25e750a75bd72975646d.png";